import React from 'react';
import { Grid } from '@mui/material';
import AddIcon from '@mui/icons-material/Add';
import RemoveIcon from '@mui/icons-material/Remove';
import ActionButton from './ActionButton';

const DesktopButtons = ({
  isLast,
  index,
  maxSections,
  addFlightSection,
  removeFlightSection,
  totalSections,
}) => {
  const showRemove = totalSections > 1;
  const showAdd = isLast && totalSections < maxSections;

  return (
    <Grid
      item
      sx={{
        display: { xs: 'none', md: 'flex' },
        flex: '0 0 135px',
        justifyContent: 'center',
        gap: 1,
      }}
      style={{
        position: 'absolute',
        right: '-80px',
      }}
    >
      {showRemove && !showAdd && (
        <ActionButton
          onClick={() => removeFlightSection(index)}
          background="#FFFFFF"
          hoverBackground="#FFFFFF"
          border="1px solid #636466"
          icon={<RemoveIcon sx={{ color: '#636466' }} />}
          iconColor="#636466"
          width={'100%'}
        />
      )}

      {showAdd && (
        <ActionButton
          onClick={() => addFlightSection(index)}
          background={theme => theme.palette.tertiary?.main || '#1976d2'}
          hoverBackground={theme => theme.palette.tertiary?.main || '#115293'}
          icon={<AddIcon sx={{ color: '#FFFFFF' }} />}
          iconColor="#FFFFFF"
          width={'100%'}
        />
      )}
    </Grid>
  );
};

export default DesktopButtons;
